<template>
  <div class="home-container">
    <div class="content-wrapper">
      <!-- 使用图片占满轮播项，保持比例裁剪 -->
      <div class="img-container">
        <img :src="require(`@/assets/homepage/slide1.png`)" alt="轮播图片" />
      </div>
      <div class="header-container">
        <Header></Header>
      </div>
      <!--统计清单-->
      <div class="tongjilist-box ">
        <ImageTextComponent v-for="(item, index) in tongjiList" :key="index" :imageSrc="item.imageSrc"
          :imageAlt="item.imageAlt" :numberValue="item.numberValue" :textContent="item.textContent"
          :unitText="item.unitText"
          :textColor="item.textColor" />
      </div>
      <!-- 扫码图片三个 -->
      <div class="qrcode-box">
        <ImageLink v-for="(item, index) in qrcodeList" :key="index" :imageSrc="item.imageSrc" :link="item.linkUrl" />
      </div>
      <!-- 需求成果榜单 -->
      <div>
        <h1 style="font-size: 3em;">需求成果榜单</h1>
      </div>
      <div class="container">
        <!-- 左半部分 -->
        <div class="section left-section">
          <!-- 上半部分：背景图 + 标题 -->
          <div class="section-header" :style="{ backgroundImage: `url(${leftImageUrl})` }">
            <h2 class="section-title">{{ leftTitle }}</h2>
          </div>
          <!-- 下半部分：表格 -->
          <div class="section-table scroll-table-wrap">
            <el-table style="width: 100%" border class="el-th-homepage">
              <el-table-column prop="demandName" label="需求名称" align="center"></el-table-column>
              <el-table-column prop="techField" label="技术领域" align="center"></el-table-column>
              <el-table-column prop="demandTypes" label="服务类型" align="center"></el-table-column>
            </el-table>
            <div class="scroll-table-content">
              <el-table :data="techDemands" border style="width: 100%" class="el-table-homepage">
                <el-table-column prop="demandName" label="需求名称" align="center"></el-table-column>
                <el-table-column prop="techField" label="技术领域" align="center"></el-table-column>
                <el-table-column prop="demandTypes" label="服务类型" align="center"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>

        <!-- 右半部分 -->
        <div class="section right-section">
          <!-- 上半部分：背景图 + 标题 -->
          <div class="section-header" :style="{ backgroundImage: `url(${rightImageUrl})` }">
            <h2 class="section-title">{{ rightTitle }}</h2>
          </div>

          <!-- 下半部分：表格 -->
          <div class="section-table scroll-table-wrap">
            <el-table style="width: 100%" class="el-th-homepage" show-header>
              <el-table-column prop="projectName" label="成果名称" align="center"></el-table-column>
              <el-table-column prop="category" label="技术领域" align="center"></el-table-column>
              <el-table-column prop="projectProgress" label="状态" align="center"></el-table-column>
            </el-table>
            <div class="scroll-table-content">
              <el-table :data="achievements" border style="width: 100%" class="el-table-homepage">
                <el-table-column prop="projectName" label="成果名称" align="center"></el-table-column>
                <el-table-column prop="category" label="技术领域" align="center"></el-table-column>
                <el-table-column prop="projectProgress" label="状态" align="center"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import ImageTextComponent from "../components/common/ImageTextComponent.vue"
import ImageLink from "../components/common/ImageLink.vue";
import homepageApi from "@/api/homepage.js";
import achievementApi from '@/api/achievements.js'
import techDemandApi from '@/api/demands.js';
import Header from "@/components/common/header.vue";
import Footer from "@/components/common/footer.vue";

export default {
  name: "HomePage",
  components: {
    ImageTextComponent, ImageLink, Header, Footer
  },
  data() {
    return {
      achievementsNum: 0,
      techDemandsNum: 0,
      universityNum: 0,
      instrumentNum: 0,
      enterprizeNum: 0,
      expertNum: 0,
      achievements: [],
      techDemands: [],
      qrcodeList: [
        {
          imageSrc: require('@/assets/homepage/qritem1.png'),
          linkUrl: 'https://sytpre.com/#/ViewsDetail?id=176'
        },
        {
          imageSrc: require('@/assets/homepage/qritem2.png'),
          linkUrl: 'https://sytpre.com/#/ViewsDetail?id=175'
        },
        {
          imageSrc: require('@/assets/homepage/qritem3.png'),
          linkUrl: 'https://www.sytpre.com/#/ViewsDetail?id=177'
        },

      ],
      leftImageUrl: require("@/assets/homepage/important-project-left.png"),
      leftTitle: "需求榜单",
      rightImageUrl: require("@/assets/homepage/important-project-right.png"),
      rightTitle: "成果榜单",

    }
  },
  computed: {

    tongjiList() {
      return [
        {
          imageSrc: require('@/assets/homepage/item1.png'),
          imageAlt: "科技成果",
          numberValue: this.achievementsNum,
          textContent: '科技成果',
          textColor: "rgb(36, 147, 166)"
        },
        {
          imageSrc: require('@/assets/homepage/item2.png'),
          imageAlt: '图标2',
          numberValue: this.techDemandsNum,
          textContent: '技术需求',
          textColor: "rgb(157, 170, 245)"

        },
        {
          imageSrc: require('@/assets/homepage/item3.png'),
          imageAlt: '图标3',
          numberValue: this.universityNum,
          textContent: '高校机构',
          textColor: "rgb(165, 161, 115)"
        },
        {
          imageSrc: require('@/assets/homepage/item6.png'),
          imageAlt: '图标3',
          numberValue: this.instrumentNum,
          textContent: '仪器共享',
          textColor: "#ba318c"
        },
        {
          imageSrc: require('@/assets/homepage/item7.png'),
          imageAlt: '图标3',
          numberValue: "5.7亿",//TODO,技术合同交易额修改
          textContent: '技术合同交易额',
          textColor: "rgb(60, 158, 199)",
          unitText: "元"
        },
        {
          imageSrc: require('@/assets/homepage/item4.png'),
          imageAlt: '图标3',
          numberValue: this.expertNum,
          textContent: '人才智库',
          textColor: "rgb(197, 139, 99)"
        }
      ]
    }
  },
  created() {
    this.loadAllData()
  },
  methods: {
    //加载所有数据
    async loadAllData() {
      this.achievementsNum = await homepageApi.getDataNumber("achievements")
      this.techDemandsNum = await homepageApi.getDataNumber("techDemands")
      this.universityNum = await homepageApi.getDataNumber("institutions/university")
      this.enterprizeNum = await homepageApi.getDataNumber("institutions/enterprise")
      this.expertNum = await homepageApi.getDataNumber("experts")
      this.instrumentNum = await homepageApi.getDataNumber("instrument")
      let a = await achievementApi.getList({ "pageNum": 1, "pageSize": 30 })
      this.achievements = a.data.records
      let b = await techDemandApi.getList({ "pageNum": 1, "pageSize": 30 })
      this.techDemands = b.data.records
    }
  },

};
</script>

<style scoped>
/* 数据可视化大屏按钮样式 */

.dashboard-btn {
  position: fixed;
  /* 固定定位，始终在右上角 */
  top: 20px;
  right: 20px;
  background: linear-gradient(135deg, #4361ee, #3a0ca3);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 12px 24px;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  box-shadow: 0 4px 15px rgba(67, 97, 238, 0.4);
  transition: all 0.3s ease;
  z-index: 1000;
  /* 确保按钮在其他内容上方 */
}

.blank-container {
  height: 400px;
}

/* 图片样式 */
.img-container {
  z-index: -1;
  height: 30%;
  width: 100%;
  position: absolute;
  opacity: 0.2;
  width: 100%;
  top: 0;
}

.img-container img {
  width: 100%;
  height: 100%;
  position: relative;
  object-fit: cover;
  object-position: center;
}

.dashboard-btn:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(67, 97, 238, 0.6);
  background: linear-gradient(135deg, #3a56d4, #30098f);
}

.dashboard-btn:active {
  transform: translateY(1px);
  box-shadow: 0 2px 10px rgba(67, 97, 238, 0.4);
}

.icon {
  font-style: normal;
  font-size: 1.2rem;
}

/* 主界面样式 */
.home-container {
  display: flex;
  justify-content: center;
  flex-direction: column;
}

.content-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.logo {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.title {
  display: flex;
  align-items: center;
}

.main-title {
  font-size: 3rem;
  margin: 40px;
}

/* 导航栏样式 */

.navigation {
  margin: 20px 0px;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.nav-item {
  font-size: 1.7rem;
  cursor: pointer;
  padding: 5px 15px;
  /* 左右增加内边距，让文字周围空间更均匀 */
  white-space: nowrap;
  /* 防止文字换行 */
}

.nav-item:hover {
  color: #0066cc;
}

.separator {
  color: #ccc;
  font-size: 1.2rem;
}

/*轮播图*/

.carousel-div {
  width: 100%;
}

:deep(.el-carousel__container) {
  height: 400px !important;
  width: 100%;
}

.carousel-img-container {

  width: 100%;
  height: 100%;
  /* 继承轮播图的150px高度 */
  overflow: hidden;
  /* 隐藏左右超出容器的部分 */
  position: relative;
}

.carousel-img {
  height: 100%;
  /* 高度与容器一致，保证上下内容完全显示 */
  width: auto;
  /* 宽度自适应，根据高度等比例缩放 */
  min-width: 100%;
  /* 确保图片宽度至少铺满容器（避免过窄出现空白） */
  min-height: 100%;
  position: absolute;
  /* 配合left:50%实现水平居中 */
  object-fit: contain;
  /* 可选：居中显示图片主体 */
  object-position: center;
}

/*统计清单背景*/

.tongjilist-box {
  display: flex;
  /* 宽度占父容器的80% */
  width: 80%;
  /* 固定高度200px */
  height: 160px;
  /* 背景色为白色 */
  background-color: #ffffff;
  /* 圆角效果（可根据需要调整数值，单位px或%） */
  border-radius: 8px;
  /* 黑色轮廓线（边框），1px实线 */
  border: 1px solid #747474ff;
  justify-content: space-around;
  /* 阴影效果：x轴偏移 0，y轴偏移 2px，模糊半径 6px，阴影颜色（带透明度的黑色） */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
}

.section {
  height: 500px;
}

/* 表格滚动控制 */
.section-table {
  height: 500px;
}

/* 滚动表格容器：固定高度+溢出隐藏 */
.scroll-table-wrap {
  flex: 1;
  overflow: hidden;
  position: relative;
}

/* 滚动内容：动画主体 */
.scroll-table-content {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  /* 自动滚动动画：20秒匀速循环，可调整时长 */
  animation: scrollUp 60s linear infinite;
}

/* 鼠标悬停暂停滚动 */
.scroll-table-wrap:hover .scroll-table-content {
  animation-play-state: paused;
}

/* 滚动动画关键帧：从顶部滚动到底部 */
@keyframes scrollUp {
  0% {
    transform: translateY(0);
  }

  100% {
    /* 移动距离 = 内容高度 - 容器高度（需确保内容高度 > 容器高度才会滚动） */
    transform: translateY(calc(-100% + 400px));
    /* 400px 对应 scroll-table-wrap 的 height */
  }
}

/* 修复表格默认边距，避免滚动留白 */
:deep(.scroll-table-content .el-table) {
  margin: 0;
}

/* 二維碼清單 */
.qrcode-box {
  display: flex;
  justify-content: space-around;
}

/* 排行榜表格 */
/* 容器：左右两部分平分页面 */
.container {
  display: flex;
  width: 80vw;
  /* 占满屏幕宽度 */
  overflow: hidden;
  /* 避免滚动 */
}

/* 左右部分共用样式：各占50%宽度 */
.section {
  width: 50%;
  height: 550px;
  display: flex;
  flex-direction: column;
}

/* 左半部分额外样式（可选） */
.left-section {
  margin-right: 10px;
}

/* 右半部分额外样式（可选） */
.right-section {
  margin-left: 10px;
}

/* 上半部分：背景图区域（占自身高度的50%） */
.section-header {
  background-size: contain;
  /* 背景图覆盖区域 */
  background-position: center;
  /* 背景图居中 */
  background-repeat: no-repeat;
  position: relative;
  /* 用于标题定位 */
  min-height: 130px;
  /* 确保最小高度 */
}

/* 标题样式 */
.section-title {
  color: #fff;
  /* 白色文字 */
  font-size: 24px;
  /* 较大字体 */
  /* 内边距 */
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.5);
  /* 文字阴影增强可读性 */
  position: absolute;
  /* 可自定义标题位置 */
  top: 20px;
  left: 20px;
}

:deep(.el-th-homepage th) {
  font-size: 20px;
  background-color: rgb(192, 192, 192);
  color: #2c2c2c;
  border: none;
}

:deep(.el-th-homepage .el-table__body-wrapper) {
  display: none !important;
  height: 0 !important;
}

:deep(.el-table-homepage) {
  font-size: 18px;
}

.header-container {
  height: 30% !important;
  width: 100%;
  display: block;
  flex-shrink: 0;
  padding: 50px;
  margin:3.9rem 0;
}
</style>
